import React from "react";
import { FiArrowDownRight, FiArrowUpRight } from "react-icons/fi";
import NumberFormat from "react-number-format";

function moneyMask(value) {
  return (
    <NumberFormat
      // decimalSeparator=","
      // thousandSeparator="."
      // decimalScale={2}
      // prefix="R$ "
      // displayType={'text'}
      // value={value !== undefined && value}
      value={value !== undefined ? value : 0}
      displayType={'text'}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale={true}
      prefix="R$ "
    />
  )
}

function percentualMask(value) {
  return (
    <NumberFormat
      decimalSeparator=","
      thousandSeparator="."
      decimalScale={2}
      suffix="%"
      displayType={'text'}
      value={value !== undefined && value}
    />
  )
}

export default function DashboardConsorcioBigNumbers({ data }) {
  const { bigNumbers, bigNumbersUltimoMes } = data;
  if (bigNumbers) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-2 gap-3">
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-500 truncate">
              Custo Distribuidora
            </h4>
          </div>
          <h3 className="text-xl md:text-3xl  font-bold text-gray-600">
            {moneyMask(bigNumbers && bigNumbers.custoSemConsorcio)}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Mês anterior: {moneyMask(bigNumbersUltimoMes && bigNumbersUltimoMes.custoSemConsorcio)}
          </span>
        </div>
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-500 truncate">
              Custo BRZ
            </h4>
          </div>
          <h3 className="text-xl md:text-3xl  font-bold text-gray-600">
            {moneyMask(bigNumbers && bigNumbers.custoComConsorcio)}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Mês anterior: {moneyMask(bigNumbersUltimoMes && bigNumbersUltimoMes.custoComConsorcio)}
          </span>
        </div>
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-500 truncate">
              Economia no mês
            </h4>
          </div>
          <h3 className="text-xl md:text-3xl font-bold text-gray-600">
            {moneyMask(bigNumbers && bigNumbers.economiaMes)}
            {/* <span className="text-lg md:text-2xl"> | {percentualMask(bigNumbers.percentualEconomia*100)}</span> */}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Mês anterior: {moneyMask(bigNumbersUltimoMes && bigNumbersUltimoMes.economiaMes)}
          </span>
        </div>
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <h4 className="text-sm font-medium text-gray-500 truncate">
            Economia acumulada
          </h4>
          <h3 className="text-xl md:text-3xl  font-bold text-gray-600">
            {moneyMask(bigNumbers && bigNumbers.economiaTotalAcumulada)}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Todo o periodo
          </span>
        </div>
      </div>
    );
  } else {
    return (<>
      <div className="grid grid-cols-2 md:grid-cols-2 gap-3">
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-500 truncate">
              Custo Distribuidora
            </h4>
            <div className="flex items-center gap-1">
              <>
              </>
            </div>
          </div>
          <h3 className="text-xl md:text-3xl  font-bold text-gray-600">
            {moneyMask(0)}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Mês anterior: {moneyMask(0)}
          </span>
        </div>
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-500 truncate">
              Custo BRZ
            </h4>
            <div className="flex items-center gap-1">
              <>
              </>
            </div>
          </div>
          <h3 className="text-xl md:text-3xl  font-bold text-gray-600">
            {moneyMask(0)}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Mês anterior: {moneyMask(0)}
          </span>
        </div>
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-500 truncate">
              Economia no mês
            </h4>
            <div className="flex items-center gap-1">
              <>
              </>
            </div>
          </div>
          <h3 className="text-xl md:text-3xl font-bold text-gray-600">
            {moneyMask(0)}
            {/* <span className="text-lg md:text-2xl"> | {percentualMask(bigNumbers.percentualEconomia*100)}</span> */}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Mês anterior: {moneyMask(0)}
          </span>
        </div>
        <div className="flex flex-col gap-2.5 bg-white rounded-lg drop-shadow p-4">
          <h4 className="text-sm font-medium text-gray-500 truncate">
            Economia acumulada
          </h4>
          <h3 className="text-xl md:text-3xl  font-bold text-gray-600">
            {moneyMask(0)}
          </h3>
          <span className="text-sm font-regular text-gray-500">
            Todo o periodo
          </span>
        </div>
      </div>
    </>)
  }
}
